import type { WsInvActFilter } from "../../../../../../api/wsInvActs";
import { defineFilterConfig, filterFieldAdapters } from "@src/components/business-form";

/** Значения filter-формы списка АИ УП. */
export interface WsInvActsFilterFormValues {
    commandNum: string;
    divisionCode: number | null;
    commandDate: string | null;
}

export const wsInvActsFilterFormConfig = defineFilterConfig<WsInvActsFilterFormValues, WsInvActFilter>({
    fields: {
        commandNum: {
            type: "string",
            label: "Номер АИ",
            map: filterFieldAdapters.ompSearchString("CommandNum"),
        },
        divisionCode: {
            type: "number",
            nullable: true,
            label: "Подразделение",
            map: {
                from: (domain) => domain.DivisionCodes?.[0] ?? null,
                to: (value) => ({
                    DivisionCodes: value != null ? [value] : undefined,
                }),
            },
        },
        commandDate: {
            type: "date",
            nullable: true,
            label: "Дата приказа",
            map: {
                from: (domain) => domain.CommandDate?.from ?? null,
                to: (value) => {
                    const trimmed = value?.trim() ?? "";
                    if (trimmed === "") {
                        return { CommandDate: undefined };
                    }
                    return { CommandDate: { from: trimmed, to: trimmed } };
                },
            },
        },
    },
});
